import { z } from "zod";

export const VOICE_ELIGIBILITY_PREWARM_QUEUE_NAME = "prewarmVoiceEligibility";
export const VOICE_ELIGIBILITY_PREWARM_PATH = "/api/cloudtask/prewarm-voice-eligibility";

export const voiceEligibilityPrewarmPayloadSchema = z.object({
  calledNumber: z.string().min(1),
  fromNumber: z.string().min(1),
});

export type VoiceEligibilityPrewarmPayload = z.infer<typeof voiceEligibilityPrewarmPayloadSchema>;
